import { useState } from 'react'

import { TopBar } from './TopBar'
import { LogoSection } from './LogoSection'
import { DesktopNav } from './DesktopNav'
import { DesktopSubNav } from './DesktopSubNav'
import { MobileNav } from './MobileNav'
import { useActiveNav } from './useActiveNav'

const Header = () => {

  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null)

  const {
    activeMainNav,
    getActiveSubNav,
    isSubItemActive
  } = useActiveNav()

  const microSite = new URLSearchParams(window.location.search).get('template')
  if (microSite) return null

  return (
    <header className="bg-white w-full">

      <TopBar />

      {/* MAIN HEADER */}
      <div className="bg-white mt-14 relative">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-1 relative">

          <div className="inline-flex md:flex items-center justify-between">
            <LogoSection />

            {/* MOBILE MENU TOGGLE */}
            <button
              onClick={() => setIsMobileNavOpen(v => !v)}
              className="lg:hidden p-2 text-wine-100"
            >
              ☰
            </button>
          </div>

        </div>

        {/* MOBILE NAV */}
      <MobileNav
        isOpen={isMobileNavOpen}
        openSubmenu={openSubmenu}
        setOpenSubmenu={setOpenSubmenu}
        setIsOpen={setIsMobileNavOpen}
      />
      </div>

      {/* DESKTOP NAV */}
      <DesktopNav
        activeMainNav={activeMainNav}
        getActiveSubNav={getActiveSubNav}
      />

      {/* SUB NAV */}
      <DesktopSubNav
        subNav={getActiveSubNav()}
        isSubItemActive={isSubItemActive}
      />

      

    </header>
  )
}

export default Header